import { render } from "./App.vue?vue&type=template&id=09a6b54a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09a6b54a&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__